import { Grid, Space, Text, TextInput } from '@mantine/core';
import { useEffect } from 'react';
import {
  CreateEntity,
  CreateResellerDetailsForm,
} from '../../../../type/entity.types';
import SelectPartnerFilter from '../../../filters/select-partner-filter.component';
import XCol6 from '../../../x-components/grid-col/x-col-6.component';
import {
  EntityFilterData,
  EntityIdFilterData,
} from '../../../../type/filter.types';
import { useForm } from '@mantine/form';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import useAuth from '../../../../hooks/useAuth';
import { Roles } from '../../../../enums/roles-enum';

function ResellerDetails(props: Props) {
  const { form, isAdmin } = props;

  const filterData = useForm<EntityFilterData>({
    initialValues: {
      partnersData: [],
    },
  });
  const filterValues = useForm<EntityIdFilterData>({
    initialValues: {
      partner: undefined,
    },
  });

  useEffect(() => {
    if (!isAdmin) {
      return;
    }

    form.setFieldValue('partnerId', filterValues.values.partner);
  }, [filterValues.values]);

  return (
    <>
      <Text size='xl' weight={700}>
        Reseller Details
      </Text>
      <Space h='xl' />
      <Grid>
        {isAdmin && (
          <>
            <XCol6>
              <SelectPartnerFilter
                filterSelectData={filterData}
                filterValues={filterValues}
                error={form.errors.partnerId}
              />
            </XCol6>
            <XCol6></XCol6>
          </>
        )}

        <XCol6>
          <TextInput
            label={labels.entityName}
            placeholder={placeholders.entityName}
            {...form.getInputProps('entityName')}
          />
        </XCol6>
        <XCol6>
          <TextInput
            label={labels.emailAddress}
            placeholder={placeholders.emailAddress}
            {...form.getInputProps('email')}
          />
        </XCol6>
      </Grid>
    </>
  );
}

const labels = {
  entityName: 'Reseller name',
  emailAddress: 'Company email',
};
const placeholders = {
  entityName: 'Reseller name',
  emailAddress: 'Company email',
};

export default ResellerDetails;

interface Props {
  form: UseFormReturnType<CreateResellerDetailsForm>;
  isAdmin: boolean;
}
